define("checkout/components/seamless-checkout-table", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "moment"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking, _moment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"moment"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Plan + Add-Ons }}
  <section class="tCK--table">
    <hr class={{concat-classes (if (and @canAddons this.isSimplifiedCheckout) "u--hide" "tCK--table__divider")}} />
    {{! Row - Plan Price }}
    <div class="tCK--table__row">
      <div class="tCK--table__data u--flex__basics--auto">
        <span class="u--text--bold">
          {{t "plans.checkout.plan.line_item_plan" name=@selectedSubscriptionPlan.displayName}}
        </span>
        {{#if (and @canAddons this.isSimplifiedCheckout)}}
          <Shared::Ui::Button
            @onClick={{this.toggleAddonVisibility}}
            @text={{if this.hideAddons (t "checkout.addon_details.show") (t "checkout.addon_details.hide")}}
            @variant="unstyled"
            class="o--btn--actionLink u--m__l__sm u--text--uppercase"
          />
        {{/if}}
      </div>
      <div class="tCK--table__data u--flex__justify--end">
        <span>{{format-currency @selectedSubscriptionPlan.amount}}</span>
      </div>
    </div>
    <hr class={{concat-classes (if (and @canAddons this.isSimplifiedCheckout) "tCK--table__divider" "u--hide")}} />
    {{! Row - Social Set }}
    <div class={{concat-classes "tCK--table__row" (if this.hideAddons "u--hide")}}>
      <div class="tCK--table__data">
        <span>{{t "shared_phrases.social_sets.info.header"}}</span>
      </div>
      {{#if @canAddons}}
        <div class="tCK--table__data u--flex__justify--center">
          <InputStepper
            @currentValue={{add @selectedSubscriptionPlan.numberOfSocialSets @additionalSocialSetCount}}
            @didAutoAdd={{@didAutoAddSocialSet}}
            @id={{"socialSets"}}
            @minValue={{@selectedSubscriptionPlan.numberOfSocialSets}}
            @onStepDown={{fn @onSocialSetChange -1}}
            @onStepUp={{fn @onSocialSetChange 1}}
            @testId="additional-social-sets"
            @tooltipAtMin={{t
              "plans.checkout.addons.tooltip_at_minimum"
              numSocialSets=@selectedSubscriptionPlan.numberOfSocialSets
              numUsers=@selectedSubscriptionPlan.numberOfUsers
              planName=@selectedSubscriptionPlan.displayName
            }}
          />
        </div>
        <div class="tCK--table__data u--flex__justify--end">
          <span data-test-id="additional-social-sets-cost"> {{format-currency @totalSocialSetCost}} </span>
        </div>
      {{else}}
        <div class="tCK--table__data u--flex__justify--center">
          <span class="o--btn o--btn--outline u--text--light u--mute qa--input_counter" data-test-id="change">
            {{@selectedSubscriptionPlan.numberOfSocialSets}}
            <EmberTooltip @delay={{330}} @side="top">
              {{t "plans.checkout.addons.tooltip_feature_unavailable"}}
            </EmberTooltip>
          </span>
        </div>
        <div class="tCK--table__data u--flex__justify--end"></div>
      {{/if}}
    </div>
    {{! Row - Users }}
    <div class={{concat-classes "tCK--table__row" (if this.hideAddons "u--hide")}}>
      <div class="tCK--table__data"><span>{{t "shared_words.users"}}</span></div>
      {{#if @canAddons}}
        <div class="tCK--table__data u--flex__justify--center">
          <InputStepper
            @currentValue={{add @selectedSubscriptionPlan.numberOfUsers @additionalTeamMemberCount}}
            @didAutoAdd={{@didAutoAddUser}}
            @id={{"users"}}
            @minValue={{@selectedSubscriptionPlan.numberOfUsers}}
            @onStepDown={{fn @onTeamMemberChange -1}}
            @onStepUp={{fn @onTeamMemberChange 1}}
            @testId="additional-team-members"
            @tooltipAtMin={{t
              "plans.checkout.addons.tooltip_at_minimum"
              numSocialSets=@selectedSubscriptionPlan.numberOfSocialSets
              numUsers=@selectedSubscriptionPlan.numberOfUsers
              planName=@selectedSubscriptionPlan.displayName
            }}
          />
        </div>
        <div class="tCK--table__data u--flex__justify--end">
          <span data-test-id="additional-team-members-cost">{{format-currency @totalTeamMemberCost}}</span>
        </div>
      {{else}}
        <div class="tCK--table__data u--flex__justify--center">
          <span class="o--btn o--btn--outline u--text--light u--mute qa--input_counter" data-test-id="change">
            {{@selectedSubscriptionPlan.numberOfUsers}}
            <EmberTooltip @delay={{330}} @side="top">
              {{t "plans.checkout.addons.tooltip_feature_unavailable"}}
            </EmberTooltip>
          </span>
        </div>
        <div class="tCK--table__data u--flex__justify--end"></div>
      {{/if}}
    </div>
  
    {{! Row - Credits }}
    {{! Title }}
    <div class="tCK--table__row u--m__t__md">
      <div class="tCK--table__data">
        <span class="u--text--bold">
          {{t "plans.checkout.addons.ai_credits.label"}}
        </span>
        <span class="u--m__l__sm">
          {{t "plans.checkout.addons.ai_credits.total" amount=@totalAiCredits}}
        </span>
      </div>
    </div>
    {{! Credits Included }}
    <div class="tCK--table__row tCK--table__row--hl">
      <div class="tCK--table__data">
        {{svg-jar "credit" class="o--icon tCK--table__icon"}}
        <span>
          {{t
            "plans.checkout.addons.ai_credits.included"
            amount=@selectedSubscriptionPlan.numberOfAiCredits
            plan=@selectedSubscriptionPlan.name
          }}
        </span>
      </div>
    </div>
    {{! Extra Credits }}
    <div class="tCK--table__row tCK--table__row--hl">
      <div class="tCK--table__data">
        {{svg-jar "credit-pack" class="o--icon--md tCK--table__icon"}}
        <div class="u--flex__col">
          <p class="u--m__b__0">{{t "plans.checkout.addons.ai_credits.title"}}</p>
          <span class="u--text--light u--text--sm">{{t "plans.checkout.addons.ai_credits.sub_title"}}</span>
        </div>
      </div>
      {{#if @canAddAiCredits}}
        <div class="tCK--table__data u--flex__justify--center">
          <InputStepper
            @currentValue={{@additionalAiCredits}}
            @didAutoAdd={{false}}
            @id={{"credits"}}
            @minValue={{0}}
            @onStepDown={{fn @onAiCreditsChange -1}}
            @onStepUp={{fn @onAiCreditsChange 1}}
          />
        </div>
        <div class="tCK--table__data u--flex__justify--end">
          <span>{{format-currency @totalAiCreditCost}}</span>
        </div>
      {{else}}
        <div class="tCK--table__data u--flex__justify--center">
          <span class="o--btn o--btn--outline u--text--light u--mute qa--input_counter" data-test-id="change">
            {{0}}
            <EmberTooltip @delay={{330}} @side="top">
              {{t "plans.checkout.addons.ai_credits.upgrade"}}
            </EmberTooltip>
          </span>
        </div>
        <div class="tCK--table__data u--flex__justify--end"></div>
      {{/if}}
    </div>
    {{! Extra Subtext }}
    <div class="tCK--table__row u--m__t__xs">
      <p class="u--m__0 u--text--light u--text--sm">
        {{t "plans.checkout.addons.ai_credits.description"}}
        {{#unless @selectedSubscriptionPlan.canAddAiCredits}}
          {{t "plans.checkout.addons.ai_credits.upgrade"}}
        {{/unless}}
      </p>
    </div>
    {{! Coupon }}
    {{#if (and @canApplyDiscount @discountAmount)}}
      <div class="tCK--table__row u--m__t__md qa--couponLine_seamlessCheckout">
        <div class="tCK--table__data">
          <span class="u--text--bold" data-test-id="coupon">
            {{t "plans.checkout.plan.line_item_coupon" description=this.couponDescription}}
          </span>
        </div>
        <div class="tCK--table__data u--flex__justify--end">
          <span data-test-id="coupon-cost">{{concat "-" (format-currency @discountAmount)}}</span>
        </div>
      </div>
    {{/if}}
    {{! Alert }}
    {{#if @alertText}}
      <div class="tCK--table__row">
        <AlertBanner @text={{@alertText}} />
      </div>
    {{/if}}
    <hr class="tCK--table__divider" />
    {{! Subtotal for current billing}}
    <SeamlessCheckoutTable::Charges
      @currentSubscriptionPlan={{@currentSubscriptionPlan}}
      @discountAmount={{@discountAmount}}
      @hasActiveTrial={{@hasActiveTrial}}
      @hasCheckoutChanges={{@hasCheckoutChanges}}
      @hasExpiringDiscount={{@hasExpiringDiscount}}
      @isEligibleForTrial={{@isEligibleForTrial}}
      @isMonthly={{@isMonthly}}
      @proration={{@proration}}
      @remainingDiscountDuration={{this.remainingDiscountDuration}}
      @selectedSubscriptionPlan={{@selectedSubscriptionPlan}}
    />
  </section>
  */
  {
    "id": "nDzE25yv",
    "block": "[[[10,\"section\"],[14,0,\"tCK--table\"],[12],[1,\"\\n  \"],[10,\"hr\"],[15,0,[28,[37,0],[[52,[28,[37,2],[[30,1],[30,0,[\"isSimplifiedCheckout\"]]],null],\"u--hide\",\"tCK--table__divider\"]],null]],[12],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__basics--auto\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"plans.checkout.plan.line_item_plan\"],[[\"name\"],[[30,2,[\"displayName\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[28,[37,2],[[30,1],[30,0,[\"isSimplifiedCheckout\"]]],null],[[[1,\"        \"],[8,[39,4],[[24,0,\"o--btn--actionLink u--m__l__sm u--text--uppercase\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,0,[\"toggleAddonVisibility\"]],[52,[30,0,[\"hideAddons\"]],[28,[37,3],[\"checkout.addon_details.show\"],null],[28,[37,3],[\"checkout.addon_details.hide\"],null]],\"unstyled\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,5],[[30,2,[\"amount\"]]],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[15,0,[28,[37,0],[[52,[28,[37,2],[[30,1],[30,0,[\"isSimplifiedCheckout\"]]],null],\"tCK--table__divider\",\"u--hide\"]],null]],[12],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[15,0,[28,[37,0],[\"tCK--table__row\",[52,[30,0,[\"hideAddons\"]],\"u--hide\"]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n      \"],[10,1],[12],[1,[28,[35,3],[\"shared_phrases.social_sets.info.header\"],null]],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@currentValue\",\"@didAutoAdd\",\"@id\",\"@minValue\",\"@onStepDown\",\"@onStepUp\",\"@testId\",\"@tooltipAtMin\"],[[28,[37,7],[[30,2,[\"numberOfSocialSets\"]],[30,3]],null],[30,4],\"socialSets\",[30,2,[\"numberOfSocialSets\"]],[28,[37,8],[[30,5],-1],null],[28,[37,8],[[30,5],1],null],\"additional-social-sets\",[28,[37,3],[\"plans.checkout.addons.tooltip_at_minimum\"],[[\"numSocialSets\",\"numUsers\",\"planName\"],[[30,2,[\"numberOfSocialSets\"]],[30,2,[\"numberOfUsers\"]],[30,2,[\"displayName\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n        \"],[10,1],[14,\"data-test-id\",\"additional-social-sets-cost\"],[12],[1,\" \"],[1,[28,[35,5],[[30,6]],null]],[1,\" \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--btn o--btn--outline u--text--light u--mute qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n          \"],[1,[30,2,[\"numberOfSocialSets\"]]],[1,\"\\n          \"],[8,[39,9],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[\"plans.checkout.addons.tooltip_feature_unavailable\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[15,0,[28,[37,0],[\"tCK--table__row\",[52,[30,0,[\"hideAddons\"]],\"u--hide\"]],null]],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data\"],[12],[10,1],[12],[1,[28,[35,3],[\"shared_words.users\"],null]],[13],[13],[1,\"\\n\"],[41,[30,1],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@currentValue\",\"@didAutoAdd\",\"@id\",\"@minValue\",\"@onStepDown\",\"@onStepUp\",\"@testId\",\"@tooltipAtMin\"],[[28,[37,7],[[30,2,[\"numberOfUsers\"]],[30,7]],null],[30,8],\"users\",[30,2,[\"numberOfUsers\"]],[28,[37,8],[[30,9],-1],null],[28,[37,8],[[30,9],1],null],\"additional-team-members\",[28,[37,3],[\"plans.checkout.addons.tooltip_at_minimum\"],[[\"numSocialSets\",\"numUsers\",\"planName\"],[[30,2,[\"numberOfSocialSets\"]],[30,2,[\"numberOfUsers\"]],[30,2,[\"displayName\"]]]]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n        \"],[10,1],[14,\"data-test-id\",\"additional-team-members-cost\"],[12],[1,[28,[35,5],[[30,10]],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--btn o--btn--outline u--text--light u--mute qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n          \"],[1,[30,2,[\"numberOfUsers\"]]],[1,\"\\n          \"],[8,[39,9],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[\"plans.checkout.addons.tooltip_feature_unavailable\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--table__row u--m__t__md\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--bold\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.label\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--m__l__sm\"],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.total\"],[[\"amount\"],[[30,11]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--table__row tCK--table__row--hl\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n      \"],[1,[28,[35,10],[\"credit\"],[[\"class\"],[\"o--icon tCK--table__icon\"]]]],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.included\"],[[\"amount\",\"plan\"],[[30,2,[\"numberOfAiCredits\"]],[30,2,[\"name\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--table__row tCK--table__row--hl\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n      \"],[1,[28,[35,10],[\"credit-pack\"],[[\"class\"],[\"o--icon--md tCK--table__icon\"]]]],[1,\"\\n      \"],[10,0],[14,0,\"u--flex__col\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.title\"],null]],[13],[1,\"\\n        \"],[10,1],[14,0,\"u--text--light u--text--sm\"],[12],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.sub_title\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,12],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@currentValue\",\"@didAutoAdd\",\"@id\",\"@minValue\",\"@onStepDown\",\"@onStepUp\"],[[30,13],false,\"credits\",0,[28,[37,8],[[30,14],-1],null],[28,[37,8],[[30,14],1],null]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n        \"],[10,1],[12],[1,[28,[35,5],[[30,15]],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--center\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"o--btn o--btn--outline u--text--light u--mute qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n          \"],[1,0],[1,\"\\n          \"],[8,[39,9],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.upgrade\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"tCK--table__row u--m__t__xs\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--m__0 u--text--light u--text--sm\"],[12],[1,\"\\n      \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.description\"],null]],[1,\"\\n\"],[41,[51,[30,2,[\"canAddAiCredits\"]]],[[[1,\"        \"],[1,[28,[35,3],[\"plans.checkout.addons.ai_credits.upgrade\"],null]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[41,[28,[37,2],[[30,16],[30,17]],null],[[[1,\"    \"],[10,0],[14,0,\"tCK--table__row u--m__t__md qa--couponLine_seamlessCheckout\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"coupon\"],[12],[1,\"\\n          \"],[1,[28,[35,3],[\"plans.checkout.plan.line_item_coupon\"],[[\"description\"],[[30,0,[\"couponDescription\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"tCK--table__data u--flex__justify--end\"],[12],[1,\"\\n        \"],[10,1],[14,\"data-test-id\",\"coupon-cost\"],[12],[1,[28,[35,12],[\"-\",[28,[37,5],[[30,17]],null]],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[41,[30,18],[[[1,\"    \"],[10,0],[14,0,\"tCK--table__row\"],[12],[1,\"\\n      \"],[8,[39,13],null,[[\"@text\"],[[30,18]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,\"hr\"],[14,0,\"tCK--table__divider\"],[12],[13],[1,\"\\n\"],[1,\"  \"],[8,[39,14],null,[[\"@currentSubscriptionPlan\",\"@discountAmount\",\"@hasActiveTrial\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@isEligibleForTrial\",\"@isMonthly\",\"@proration\",\"@remainingDiscountDuration\",\"@selectedSubscriptionPlan\"],[[30,19],[30,17],[30,20],[30,21],[30,22],[30,23],[30,24],[30,25],[30,0,[\"remainingDiscountDuration\"]],[30,2]]],null],[1,\"\\n\"],[13]],[\"@canAddons\",\"@selectedSubscriptionPlan\",\"@additionalSocialSetCount\",\"@didAutoAddSocialSet\",\"@onSocialSetChange\",\"@totalSocialSetCost\",\"@additionalTeamMemberCount\",\"@didAutoAddUser\",\"@onTeamMemberChange\",\"@totalTeamMemberCost\",\"@totalAiCredits\",\"@canAddAiCredits\",\"@additionalAiCredits\",\"@onAiCreditsChange\",\"@totalAiCreditCost\",\"@canApplyDiscount\",\"@discountAmount\",\"@alertText\",\"@currentSubscriptionPlan\",\"@hasActiveTrial\",\"@hasCheckoutChanges\",\"@hasExpiringDiscount\",\"@isEligibleForTrial\",\"@isMonthly\",\"@proration\"],false,[\"concat-classes\",\"if\",\"and\",\"t\",\"shared/ui/button\",\"format-currency\",\"input-stepper\",\"add\",\"fn\",\"ember-tooltip\",\"svg-jar\",\"unless\",\"concat\",\"alert-banner\",\"seamless-checkout-table/charges\"]]",
    "moduleName": "checkout/components/seamless-checkout-table.hbs",
    "isStrictMode": false
  });

  let SeamlessCheckoutTableComponent = (_class = class SeamlessCheckoutTableComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor2, this);

      _initializerDefineProperty(this, "hideAddons", _descriptor3, this);

      this.hideAddons = Boolean(this.seamlessCheckoutManager.isSimplifiedCheckout);
    }

    get couponDescription() {
      if (!this.args.coupon) {
        if (this.args.discount) {
          return this.args.discount.name;
        }

        return null;
      }

      const name = this.args.coupon.name || this.args.coupon.id;
      return this.args.coupon.percentOff ? `${name} ${this.args.coupon.percentOff}%` : `${name}`;
    }

    get hasExpiringDiscount() {
      return this.args.canApplyDiscount && ((this.args.coupon?.durationInMonths ?? 0) > 0 || (this.args.discount?.endTime ?? 0) > 0);
    }

    get remainingDiscountDuration() {
      if (!this.args.discount?.endTime && this.args.coupon?.durationInMonths) {
        return (0, _moment.default)().add(this.args.coupon.durationInMonths, 'months').format('MMM DD, YYYY');
      }

      if (this.args.discount) {
        return (0, _moment.default)(this.args.discount.endTime * 1000).format('MMM DD, YYYY');
      }

      return;
    }

    get isSimplifiedCheckout() {
      return this.seamlessCheckoutManager.isSimplifiedCheckout;
    }

    toggleAddonVisibility() {
      this.hideAddons = !this.hideAddons;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hideAddons", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "toggleAddonVisibility", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAddonVisibility"), _class.prototype)), _class);
  _exports.default = SeamlessCheckoutTableComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SeamlessCheckoutTableComponent);
});